import React from "react";
import { ScaleRow } from "./ScaleRow";
import { ZONES, SIDES, ONSET, PAIN_TYPE } from "../../lib/wellness";

const chip = (on) => ({ padding: "9px 12px", fontSize: 13, cursor: "pointer", border: `1px solid ${on ? "#E11D2E" : "rgba(255,255,255,0.12)"}`, background: on ? "rgba(225,29,46,0.15)" : "rgba(255,255,255,0.03)", color: on ? "#fff" : "#d4d4d4" });
const H = ({ children }) => <div style={{ fontWeight: 700, fontSize: 14, margin: "14px 0 8px" }}>{children}</div>;

const ZonePicker = ({ zones, setZones }) => {
  const find = (k) => zones.find((z) => z.zone === k);
  const toggle = (k, bilateral) => setZones(find(k) ? zones.filter((z) => z.zone !== k) : [...zones, { zone: k, side: bilateral ? "derecha" : "central" }]);
  const side = (k, s) => setZones(zones.map((z) => (z.zone === k ? { ...z, side: s } : z)));
  return (
    <div data-testid="wb-zones">
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {ZONES.map(([k, l, bi]) => <button key={k} type="button" style={chip(!!find(k))} onClick={() => toggle(k, bi)} data-testid={`wb-zone-${k}`}>{l}</button>)}
      </div>
      {zones.filter((z) => ZONES.find(([k]) => k === z.zone)?.[2]).map((z) => (
        <div key={z.zone} style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 8, fontSize: 13 }}>
          <span style={{ minWidth: 120, color: "#a3a3a3" }}>{ZONES.find(([k]) => k === z.zone)[1]}</span>
          {SIDES.map(([s, l]) => <button key={s} type="button" style={{ ...chip(z.side === s), padding: "6px 10px", fontSize: 12 }} onClick={() => side(z.zone, s)} data-testid={`wb-side-${z.zone}-${s}`}>{l}</button>)}
        </div>
      ))}
    </div>
  );
};

export const PainSection = ({ f, set }) => (
  <div>
    <ScaleRow label="Dolor o molestias" hint="0 = nada · 10 = dolor máximo" min={0} max={10} value={f.pain} onChange={(v) => set({ pain: v })} reverse ends={["Nada", "Máximo"]} testid="wb-pain" />
    {f.pain > 0 && (
      <div className="qv-card-app" style={{ padding: 14, marginBottom: 18 }} data-testid="wb-pain-details">
        <H>¿Dónde lo notas? (puedes marcar varias zonas)</H>
        <ZonePicker zones={f.pain_zones} setZones={(z) => set({ pain_zones: z })} />
        <H>¿Qué tipo de molestia es?</H>
        <div style={{ display: "grid", gap: 6 }}>
          {Object.entries(PAIN_TYPE).map(([k, [l, d]]) => (
            <button key={k} type="button" style={{ ...chip(f.pain_type === k), textAlign: "left" }} onClick={() => set({ pain_type: k })} data-testid={`wb-ptype-${k}`}>
              <b>{l}</b><div style={{ fontSize: 12, color: "#a3a3a3", marginTop: 2 }}>{d}</div>
            </button>
          ))}
        </div>
        <H>¿Cuándo apareció?</H>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {Object.entries(ONSET).map(([k, l]) => <button key={k} type="button" style={chip(f.pain_onset === k)} onClick={() => set({ pain_onset: k })} data-testid={`wb-onset-${k}`}>{l}</button>)}
        </div>
      </div>
    )}
  </div>
);
